import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import TableComponent from "../reusableComponents/Table";
import Loader from "../components/Loader";
import Repo from "../../Repository/Repo";

const headRow = ["Date", "Action", "Old Value", "Change", "New Value"];
const tableBody = [`created_at`, `action`, `oldValue`, `change`, `newValue`];

function ShowItemsDetails({ onClose, name }) {
  const [loading, setLoading] = useState(false);
  const [itemDetails, setItemsDetails] = useState([]);

  useEffect(() => {
    getItemDetails();
  }, []);

  const getItemDetails = () => {
    try {
      setLoading(true);

      Repo.default({
        request: {
          method: "getItemHistoryByName",
          data: {
            company_code: localStorage.getItem("companyCode"),
            name: name,
          },
        },
      }).then((res) => {
        setItemsDetails(res.data.response.data.quantity);
        setLoading(false);
      });
    } catch (err) {
      setLoading(false);
      console.log("err:", err);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        {loading && <Loader loading={true} />}
        {!loading && (
          <TableComponent
            headRow={headRow}
            rows={itemDetails}
            tableBody={tableBody}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ShowItemsDetails;
